import { gql } from '@apollo/client';

export const SUPPLEMENTAL_CHARGE_FIELDS = gql`
    fragment SupplementalChargeFields on invoice_supplemental_charges {
        supplemental_charge_id
        invoice_id
        code
        description
        qbo_tag
        rate
        quantity
        created_at
    }
`;
